/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import XngCarousel from "@rc/App/Components/XngCarousel/XngCarousel";
import ProductCarouselProduct from "@rc/Overrides/Components/ProductCarouselProduct";
import { ProductCardSelections } from "@rc/Overrides/Widgets/ProductList/ProductCardSelections";
import React, { FC } from "react";
import { css } from "styled-components";

interface Props {
    id: string;
    fields: ProductCardSelections;
    products: ProductModel[];
}

const ProductCarouselComponent: FC<Props> = ({ id, fields, products }) => {
    if (!products?.length) {
        return null;
    }
    const queryString = (window as any).location.search || "";
    const productsSlides = products.map((product, index) => (
        <ProductCarouselProduct
            key={`${product.id}_${queryString}`}
            carouselId={id}
            carouselType={fields.carouselType}
            index={index}
            product={product}
            // recommendationId={getProductRecommendationId(product)}
            showImage={fields.showImage}
            showBrand={fields.showBrand}
            showTitle={fields.showTitle}
            showPartNumbers={fields.showPartNumbers}
            showAttributes={fields.showAttributes}
            showPrice={fields.showPrice}
            showAddToCart={fields.showAddToCart}
            showAddToList={fields.showAddToList}
            showImageBadges={fields.showImageBadges}
            maximumNumberOfImageBadges={fields.maximumNumberOfImageBadges}
            showTextBadges={fields.showTextBadges}
            maximumNumberOfTextBadges={fields.maximumNumberOfTextBadges}
        />
    ));

    return (
        <StyledWrapper
            css={css`
                > div {
                    display: flex;
                    justify-content: center;
                }
                @media print {
                    display: none;
                }
            `}
        >
            <XngCarousel
                navigationOutSide={false}
                slidesPerView={1}
                spaceBetween={20}
                navigation={true}
                breakpoints={{
                    480: {
                        slidesPerView: 1,
                    },
                    600: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                    1200: {
                        slidesPerView: 4,
                    },
                }}
            >
                {productsSlides}
            </XngCarousel>
        </StyledWrapper>
    );
};

export default ProductCarouselComponent;
